/**
 * @description: 枚举常量管理
 */
// start===========
// 订单状态
export const ENUM_ORDER_STATE = {
	0: '待支付',
	1: '已支付',
	2: '已取消',
	4: '已作废',
	10: '待审核'
}

// 订单状态枚举（用于CSS类名和状态比较）
export const ORDER_STATE = {
	UNPAID: 0, // 待支付
	PAID: 1, // 已支付
	CANCELLED: 2, // 已取消
	ABOLISH: 4, // 已作废
	WAITAUDIT: 10 // 待审核
}

// 订单状态对应的CSS类名
export const ORDER_STATE_CLASS = {
	[ORDER_STATE.UNPAID]: 'unpaid',
	[ORDER_STATE.PAID]: 'success',
	[ORDER_STATE.CANCELLED]: 'cancelled',
	[ORDER_STATE.ABOLISH]: 'abolish',
	[ORDER_STATE.WAITAUDIT]: 'waitaudit'
}
// end===========

// start===========
// 订单类型
export const ENUM_ORDER_TYPE = {
	MEMBER_VIP: '高级会员',
	MEMBER_SVIP: '超级会员',
	PACKAGE: '加油包'
}

// 订单类型（用于CSS类名和状态比较）
export const ORDER_TYPE = {
	MEMBER_VIP: 'MEMBER_VIP',
	MEMBER_SVIP: 'MEMBER_SVIP',
	PACKAGE: 'PACKAGE'
}
// end===========

// start===========
// 企业宣传、风采审核状态
export const ENUM_MERCHANT_ORDER_STATE = {
	0: '待审核',
	1: '已通过',
	2: '未通过'
}

// 企业宣传、风采审核状态枚举（用于CSS类名和状态比较）
export const MERCHANT_ORDER_STATE = {
	WAITAUDIT: 0, // 待审核
	PASSED: 1, // 已通过
	REJECTED: 2 // 未通过
}

// 企业宣传、风采审核状态对应的CSS类名
export const MERCHANT_ORDER_STATE_CLASS = {
	[MERCHANT_ORDER_STATE.WAITAUDIT]: 'waitaudit',
	[MERCHANT_ORDER_STATE.PASSED]: 'passed',
	[MERCHANT_ORDER_STATE.REJECTED]: 'rejected'
}

// end===========

// start===========
// 发票状态
export const ENUM_INVOICE_STATE = {
	0: '待开票',
	1: '已开票',
	2: '申请中'
}

// 发票状态枚举（用于CSS类名和状态比较）
export const INVOICE_STATE = {
	PENDING: 0, // 待开票
	COMPLETED: 1, // 已开票
	PROCESSING: 2 // 申请中
}

// 发票状态对应的CSS类名
export const INVOICE_STATE_CLASS = {
	[INVOICE_STATE.PENDING]: 'pending',
	[INVOICE_STATE.COMPLETED]: 'completed',
	[INVOICE_STATE.PROCESSING]: 'processing'
}
// end===========

// start===========
// 发票类型
export const ENUM_INVOICE_TYPE_STATE = {
	0: '增值税普通发票',
	1: '增值税专用发票'
}
// end===========

// start===========
// 收藏类型
export const ENUM_COLLECT_TYPE_STATE = {
	1: '政策快讯',
	2: '资质查-人员',
	3: '资质查-企业',
	4: '资质查-项目'
}

// 收藏类型状态枚举（用于CSS类名和状态比较）
export const COLLECT_TYPE_STATE = {
	NEWS: '1', // 政策快讯
	PERSON: '2', // 资质查-人员
	ENTERPRISE: '3', // 资质查-企业
	PROJECT: '4' // 资质查-项目
}
// end===========

// start===========
// 资质类型编码对应名称
export const ENUM_CERT_STATE = {
	107: '建筑业企业资质',
	109: '建筑施工企业安全生产许可证',
	106: '工程监理企业资质',
	111: '房地产开发企业资质'
}
// end===========

// start===========
// 诊断报告生成状态对应名称
export const ENUM_GGENERATE_REPORT_STATE = {
	0: '未生成',
	1: '已生成',
	2: '生成中',
	3: '待人工审核',
	4: '诊断结果生成中'
}

// 诊断报告生成状态枚举（用于CSS类名和状态比较）
export const GGENERATE_REPORT_STATE = {
	UNGENERATED: 0, // 未生成
	GENERATED: 1, // 已生成
	GENERATEDING: 2, // 生成中
	MANUALLY_REVIEW: 3, // 待人工审核
	RESULT_GENERATING: 4 // 诊断结果生成中
}
// end===========

// start===========
// 企业查-高级查询-企业类型对应名称
export const ENUM_COMPANYTYPE_LIST = [
	{
		code: '勘察单位',
		name: '勘察单位'
	},
	{
		code: '设计单位',
		name: '设计单位'
	},
	{
		code: '施工单位',
		name: '施工单位'
	},
	{
		code: '监理单位',
		name: '监理单位'
	},
	{
		code: '造价单位',
		name: '造价单位'
	},
	{
		code: '审图机构',
		name: '审图机构'
	},
	{
		code: '房地产单位',
		name: '房地产单位'
	},
	{
		code: '质量检测单位',
		name: '质量检测单位'
	}
]
// end===========

// start===========
// 企业查-高级查询-资质类别对应名称
export const ENUM_CERTYPE_LIST = [
	{
		code: '102',
		name: '工程勘察资质证书'
	},
	{
		code: '103',
		name: '工程设计资质证书'
	},
	{
		code: '105',
		name: '工程造价咨询企业资质证书'
	},
	{
		code: '106',
		name: '工程监理资质证书'
	},
	{
		code: '107',
		name: '建筑业企业资质证书'
	},
	{
		code: '109',
		name: '安全生产许可证'
	},
	{
		code: '110',
		name: '建设工程质量检测机构资质证书'
	},
	{
		code: '111',
		name: '房地产开发企业资质证书'
	},
	{
		code: '112',
		name: '房地产估价机构备案证书'
	},
	{
		code: '114',
		name: '施工图审查机构资格认定书'
	},
	{
		code: '133',
		name: '劳务资质备案企业资质'
	}
]
// end===========

// start===========
// 诊断类型对应名称
export const ENUM_DIAGNOSIS_TYPE = {
	SCSQ: '首次申请',
	SJ: '升级',
	YX: '延续',
	CXHD: '重新核定',
	ZX: '增项'
}

// 诊断类型枚举（用于状态比较）
export const DIAGNOSIS_TYPE = {
	FIRST_APPLICATION: 'SCSQ', // 首次申请
	UPGRADE: 'SJ', // 升级
	EXTENSION: 'YX', // 延续
	REASSESSMENT: 'CXHD', // 重新核定
	ADDITION: 'ZX' // 增项
}
// end===========

// start===========
// 展示板块类型
export const ENUM_DISPLAY_SECTOR = {
	'1': '企业宣传',
	'2': '企业风采'
}

// 展示板块枚举（用于CSS类名和状态比较）
export const DISPLAY_SECTOR = {
	COMPANY_PROPAGANDA: '1', // 企业宣传
	COMPANY_STYLE: '2' // 企业风采
}
// end===========

// start===========
// 文件业务类型（企业宣传、企业风采购买时附件类型）
export const FILE_BUSINESS_TYPE = {
	DISPLAY_IMAGE: '展示图', // 展示图
	ATTACHMENT: '购买详情附件' // 附件资料
}
// end===========

// start===========
// 店铺状态
export const ENUM_SHOP_STATE = {
	0: '待开通',
	1: '正常经营',
	2: '已闭店'
}

export const SHOP_STATE = {
	PENDING: 0,
	NORMAL: 1,
	CLOSED: 2
}
// end===========

// start===========
// 店铺申请类型
export const ENUM_SHOP_APPLY_TYPE = {
	1: '开店申请',
	2: '资料变更申请',
	3: '闭店申请'
}

export const SHOP_APPLY_TYPE = {
	OPEN: 1,
	CHANGE: 2,
	CLOSE: 3
}
// end===========

// start===========
// 店铺申请审核状态
export const ENUM_SHOP_AUDIT_STATE = {
	0: '审核中',
	1: '审核通过',
	2: '审核不通过'
}

export const SHOP_AUDIT_STATE = {
	PENDING: 0,
	PASS: 1,
	REJECT: 2
}
// end===========
